import {
	request
} from '@/js_sdk/request.utils.js';
import {
	configStore
} from '@/stores/config.js';


export function submitOrder(data) {
	const cstore = configStore();
	data = data || {}; 
	let agreeShow = uni.getStorageSync('agreeShow')
	data['isMonitor'] = cstore.configData.isMonitor
	if(cstore.configData.isCancelInsurance == '1'){
		if(!agreeShow){
			data['isCancelInsurance'] = '0'
			data['isCancelInsuranceRefuse'] = '0'
		}else{
			data['isCancelInsurance'] = '1'
			data['isCancelInsuranceRefuse'] = '1'
		}
	}else{
		data['isCancelInsurance'] = '0'
		data['isCancelInsuranceRefuse'] = '0'
	}
	return request({
		url: '/api/prod/submitOrder',
		method: 'POST',
		data
	})
}

// 确认借款
export function confirm(data) {
	let agreeShow = uni.getStorageSync('agreeShow')
	const cstore = configStore();
	data['isMonitor'] = cstore.configData.isMonitor
	if(cstore.configData.isCancelInsurance == '1'){
		if(!agreeShow){
			data['isCancelInsurance'] = '0'
			data['isCancelInsuranceRefuse'] = '0'
		}else{
			data['isCancelInsurance'] = '1'
			data['isCancelInsuranceRefuse'] = '1'
		}
	}else{
		data['isCancelInsurance'] = '0'
		data['isCancelInsuranceRefuse'] = '0'
	}
	return request({
		url: '/api/prod/confirm',
		method: 'POST',
		data
	})
}

export function repayInfo(data) {
	let agreeShow = uni.getStorageSync('agreeShow')
	const cstore = configStore();
	if(cstore.configData.isCancelInsurance == '1'){
		if(!agreeShow){
			data['isCancelInsurance'] = '0'
			data['isCancelInsuranceRefuse'] = '0'
		}else{
			data['isCancelInsurance'] = '1'
			data['isCancelInsuranceRefuse'] = '1'
		}
	}else{
		data['isCancelInsurance'] = '0'
		data['isCancelInsuranceRefuse'] = '0'
	}
	return request({
		url: '/api/prod/repayInfo',
		method: 'POST',
		data
	})
}

// /api/prod/productInfo
export function productInfo(data) {
	let agreeShow = uni.getStorageSync('agreeShow')
	const cstore = configStore();
	if(cstore.configData.isCancelInsurance == '1'){
		if(!agreeShow){
			data['isCancelInsurance'] = '0'
			data['isCancelInsuranceRefuse'] = '0'
		}else{
			data['isCancelInsurance'] = '1'
			data['isCancelInsuranceRefuse'] = '1'
		}
	}else{
		data['isCancelInsurance'] = '0'
		data['isCancelInsuranceRefuse'] = '0'
	}
	return request({
		url: '/api/prod/productInfoForH5',
		method: 'POST',
		data
	})
}

// 获取还款凭证
export function getPayVoucher(data) {
	return request({
		url: '/api/prod/getPayVoucher',
		method: 'POST',
		data
	})
}

// 获取打款链接
export function getLoanPayLink(data={}) {
	return request({
		url: '/api/prod/getLoanPayLink',
		method: 'POST',
		data
	})
}

// 展期列表
export function extensionInfo(data) {
	return request({
		url: '/api/prod/extensionInfo',
		method: 'POST',
		data
	})
}

// 还款渠道列表
export function getRepayChannelNameList(data={}) {
	return request({
		url: '/api/prod/getRepayChannelNameList',
		method: 'POST',
		data
	})
}

// 展期列表 2.0
export function extensionInfoV2(data) {
	return request({
		url: '/api/prod/extensionInfoV2',
		method: 'POST',
		data
	})
}

// 获取还款的终端还款渠道
export function getTerminalPayList(data={}) {
	return request({
		url: '/api/prod/getTerminalPayList',
		method: 'POST',
		data
	})
}

// 获取是否展示终端还款红色提示语
export function getIsTerminalPayTip(data={}) {
	return request({
		url: '/api/prod/getIsTerminalPayTip',
		method: 'POST',
		data
	})
}

 // 分期详情预览
 export function installmentInfo(data) {
 	return request({
 		url: '/api/prod/installmentInfo',
 		method: 'POST',
 		data
 	})
 }
 
 // 分期后获取分期详情
 export function getInstallmentByDc(data) {
 	return request({
 		url: '/api/prod/getInstallmentByDc',
 		method: 'POST',
 		data
 	})
 }
 
 // 确认分期
 export function setInstallment(data) {
 	return request({
 		url: '/api/prod/setInstallment',
 		method: 'POST',
 		data
 	})
 }
 
 // 选择订单确认借款方式(预约借款)
 export function selectConfirmType(data) {
 	return request({
 		url: '/api/prod/selectConfirmType',
 		method: 'POST',
 		data
 	})
 }
 
 // 保存待领款使用优惠券的优惠券编号(预约借款)
 export function saveConfirmHolderNumbers(data) {
 	return request({
 		url: '/api/prod/saveConfirmHolderNumbers',
 		method: 'POST',
 		data
 	})
 }
 
 // 查看是否需要预约借款弹窗
 export function checkAppointLoanPop(data) {
 	return request({
 		url: '/api/prod/checkAppointLoanPop',
 		method: 'POST',
 		data
 	})
 }
 
 // 查看是否可以重新提交
 export function reSubmitOrderCheck(data) {
 	return request({
 		url: '/api/prod/reSubmitOrderCheck',
 		method: 'POST',
 		data
 	})
 }
 
 // 重新提交订单(签订限制借款重新提交用)
 export function reSubmitOrder(data) {
 	return request({
 		url: '/api/prod/reSubmitOrder',
 		method: 'POST',
 		data
 	})
 }
 
 // 获取支付渠道配置
 export function getRepayConfigList(data) {
 	return request({
 		url: '/api/prod/getRepayConfigList',
 		method: 'POST',
 		data
 	})
 }
 
 // 获取是否显示征信费字段开关
 export function creditGroup(data) {
 	return request({
 		url: '/creditGroup',
 		method: 'POST',
 		data
 	})
 }
 
 // 获取绑卡页面地址
 export function getBoundCardUrl(data) {
 	return request({
 		url: '/api/woopPay/getBoundCardUrl',
 		method: 'POST',
 		data
 	})
 }
 
 // 获取已绑卡列表
 export function getBoundCards(data) {
 	return request({
 		url: '/api/woopPay/getBoundCards',
 		method: 'POST',
 		data
 	})
 }
 
 // 直接获取绑卡页面地址
 export function getBindCardFrameUrl(data) {
 	return request({
 		url: '/api/woopPay/getBindCardFrameUrl',
 		method: 'POST',
 		data
 	})
 }
 
 // 获取咨询费开关标识
 export function getServiceFeeSwitch(data) {
 	return request({
 		url: '/api/prod/getServiceFeeSwitch',
 		method: 'POST',
 		data
 	})
 }